export type StepId = "pre" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16;

export interface StepDefinition {
    id: StepId;
    label: string;
    name: string
}

export const STEPS: StepDefinition[] = [
    {id: "pre", label: "Pre", name: "Pre-interview"},
    {id: 1, label: "1", name: "Vertical Integration"},
    {id: 2, label: "2", name: "Horizontal Integration"},
    {id: 3, label: "3", name: "Product Lifecycle"},
    {id: 4, label: "4", name: "Shop Floor Automation"},
    {id: 5, label: "5", name: "Enterprise Automation"},
    {id: 6, label: "6", name: "Facility Automation"},
    {id: 7, label: "7", name: "Shop Floor Connectivity"},
    {id: 8, label: "8", name: "Enterprise Connectivity"},
    {id: 9, label: "9", name: "Faciliy Connectivity"},
    {id: 10, label: "10", name: "Shop Floor Intelligence"},
    {id: 11, label: "11", name: "Enterprise Intelligence"},
    {id: 12, label: "12", name: "Facility Intelligence"},
    {id: 13, label: "13", name: "Workforce Development"},
    {id: 14, label: "14", name: "Leadership"},
    {id: 15, label: "15", name: "Collaboration"},
    {id: 16, label: "16", name: "Strategy and Governance"}
];

export type Mode = "pre" | "dimension";